import "marketplaceStylesheets/index.css.scss";
import "whatwg-fetch";
import "storefront/lib/i18n";
import store from "storefront/lib/store";
import onboardingLocalStorageSubscriber from "storefront/Onboarding/localStorageSubscriber";
import { hiring } from "../../lib/console_messages";
import initWebviewDOM from "../../lib/init_webview_dom";
import { routeMatches } from "../../lib/route";
import setUTMParamsCookie from "../../lib/setUTMParamsCookie";
import showFlash from "../../lib/show_flash";
import { bindActions } from "../../containers";
import renderViolationModal from "../../components/ViolationModal/render";
import renderGlobalHeader from "../../components/GlobalHeader/render";
import renderSiteBanner from "../../components/SiteBanner/render";
import renderNavOverlay from "../../components/NavOverlay/render";
import renderFooter from "../../components/Footer/render";

hiring();
// Special setup for when the app is rendered in a webview in the app.
initWebviewDOM();
const splitPaths = window.location.pathname.split("/");
const path = splitPaths[1];
showFlash();
setUTMParamsCookie();
const actions = bindActions(store);
// set the current "applied search id" using the window.location

actions.setCurrentAppliedSearchId();
// load the current user (using either document-data or making xhr)

actions.setCurrentUser();
import(
  /* webpackChunkName: "TrustStickyFooter" */
  "../../components/TrustStickyFooter/render"
).then((module) => module.default());
const violationDOMNode = window.document.getElementById(
  "global-modal-container",
);

if (violationDOMNode && !routeMatches("/about/terms")) {
  renderViolationModal(violationDOMNode, store);
}

const headerDOMNode = window.document.getElementById("globalHeader");

if (headerDOMNode) {
  renderGlobalHeader(store);
}

const siteBannerDOMNode = window.document.getElementById("siteBanner");

if (siteBannerDOMNode) {
  renderSiteBanner(store);
}

const navOverlayDOMNode = window.document.getElementById("nav-overlay");

if (navOverlayDOMNode) {
  renderNavOverlay(navOverlayDOMNode, store);
}

const footerDOMNode = window.document.getElementsByTagName("footer");

if (footerDOMNode.length) {
  // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'HTMLElement' is not assignable t... Remove this comment to see the full error message
  renderFooter(footerDOMNode[0], store);
}

// @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'Store<Record<string, any>, Actio... Remove this comment to see the full error message
store.subscribe(onboardingLocalStorageSubscriber(store));
const instagramFeedDOMNode = window.document.getElementById("instagram-feed");

if (instagramFeedDOMNode) {
  import(
    /* webpackChunkName: "InstagramFeed" */
    "../../components/Marketing/InstagramFeed"
  ).then(({ render }) => {
    // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'HTMLElement' is not assignable t... Remove this comment to see the full error message
    render(instagramFeedDOMNode);
  });
}

const articlePaths = [
  "the-editorial",
  "drycleanonly",
  "club-saint-laurent-paris",
];

if (articlePaths.includes(path)) {
  import(
    /* webpackChunkName: "setupArticle" */
    "./setupArticle"
  ).then(({ default: setupArticle }) => {
    // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'Store<Record<string, any>, Actio... Remove this comment to see the full error message
    setupArticle(store);
  });
}
